import { useMemo, useState } from "react";
import { ALL_SIZE } from "@/components/Pagination";

// İstemci-taraflı sayfalama: 10/50/80/100/Hepsi. Liste değişince güvenli klampe eder.
export function usePaged(items, initialSize = 50) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSizeRaw] = useState(initialSize);
  const total = items.length;
  const setPageSize = (s) => { setPageSizeRaw(s); setPage(1); };

  const { slice, cur } = useMemo(() => {
    if (pageSize >= ALL_SIZE) return { slice: items, cur: 1 };
    const pages = Math.max(1, Math.ceil(total / pageSize));
    const c = Math.min(page, pages);
    const start = (c - 1) * pageSize;
    return { slice: items.slice(start, start + pageSize), cur: c };
  }, [items, total, page, pageSize]);

  return { page: cur, setPage, pageSize, setPageSize, total, slice };
}

export default usePaged;
